<template>
  <IdentifyDblConfirm
    top-page-id="en007"
    previous-page-id="en008"
    next-page-id="tem001"
  >
    <template #wizard>
      <WizardGroup>
        <MainWizard :active-index="2" type="en2"></MainWizard>
        <SubWizard :active-index="2" type="upload"></SubWizard>
      </WizardGroup>
    </template>
  </IdentifyDblConfirm>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import IdentifyDblConfirm from "@/components/fileupload/IdentifyDblConfirm";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import SubWizard from "@/components/wizard/SubWizard";

export default {
  name: "En009",
  components: {
    SubWizard,
    MainWizard,
    WizardGroup,
    IdentifyDblConfirm,
  },
  setup() {
    setMeta({
      title: "ご本人さま確認書類のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,本人確認書類",
    });
  },
};
</script>

<style scoped></style>
